import { useEffect } from 'react'
import { supabase } from './supabase'
import { useAuth } from './auth.jsx'

/**
 * Subscribe to realtime INSERT/UPDATE/DELETE events on `table` for the current
 * user and call `onChange` with the payload. Use to invalidate React Query.
 *
 * @param {string} table       Postgres table name
 * @param {(payload:any)=>void} onChange
 */
export function useRealtimeRefetch(table, onChange) {
  const { user } = useAuth()

  useEffect(() => {
    if (!user || !table) return
    const channel = supabase
      .channel(`rt-${table}-${user.id}`)
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table, filter: `user_id=eq.${user.id}` },
        (payload) => onChange?.(payload),
      )
      .subscribe()
    return () => { supabase.removeChannel(channel) }
  }, [table, user?.id, onChange])
}
